import { render, staticRenderFns } from "./hotelSubNav.vue?vue&type=template&id=4d9f5f93&scoped=true"
import script from "./hotelSubNav.vue?vue&type=script&lang=js"
export * from "./hotelSubNav.vue?vue&type=script&lang=js"
import style0 from "./hotelSubNav.vue?vue&type=style&index=0&id=4d9f5f93&lang=scss"
import style1 from "./hotelSubNav.vue?vue&type=style&index=1&id=4d9f5f93&lang=sass&scoped=true"
import style2 from "./hotelSubNav.vue?vue&type=style&index=2&id=4d9f5f93&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f5f93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9f5f93')) {
      api.createRecord('4d9f5f93', component.options)
    } else {
      api.reload('4d9f5f93', component.options)
    }
    module.hot.accept("./hotelSubNav.vue?vue&type=template&id=4d9f5f93&scoped=true", function () {
      api.rerender('4d9f5f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hotel/components/hotelSubNav.vue"
export default component.exports